import apiClient from './api-client';

const usuariosService = {
    listar: async () => {
        try {
          const response = await apiClient.get('/usuarios');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      obter: async (id) => {
        try {
          const response = await apiClient.get(`/usuarios/${id}`);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      inserir: async (data) => {
        try {
          const response = await apiClient.post('/usuarios', data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      atualizar: async (id, data) => {
        try {
          const response = await apiClient.patch(`/usuarios/${id}`, data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      }
}

export default usuariosService;